<template>
  <v-content pa-0>
    <Header></Header>
    <div
      style="position: relative;display: flex;justify-content: center;align-items: center"
      :style="$vuetify.breakpoint.mdAndUp ? {'padding-top': '88px'}:{}"
    >
      <v-img
        style="width: 100%"
        max-height="500px"
        :src="$vuetify.breakpoint.smAndDown ? http + aboutBanner.mobile_img : http + aboutBanner.desktop_img"
      ></v-img>
    </div>
    <v-container>
      <v-layout justify-center my-10 text-left>
        <v-flex xs11 sm10 md9>
          <div v-if="language=='en'" class="aboutContent" v-html="description.en"></div>
          <div v-if="language=='th'" class="aboutContent" v-html="description.th"></div>
        </v-flex>
      </v-layout>
    </v-container>
    <Footer></Footer>
  </v-content>
</template>
<script>
import { mapActions, mapState } from "vuex";

import Header from "../components/Header";
import Footer from "../components/Footer";

import Service from "../services";
import {domain} from "../services/Constants";

export default {
  name: "about",
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState({
      aboutBanner: state => state.banner.aboutBanner,
      language: state => state.locale.language
    })
  },
  data: () => ({
    description: { th: null, en: null },
    http: domain
  }),
  created() {
    Service.webdata.getAboutPage().then(res => {
      this.description.th = res.description_th;
      this.description.en = res.description_en;
    });

    this.$store.dispatch('banner/onGetAllBanners');
    Service.analytics.sendPageView({
      path: this.$route.path
    })
  }
};
</script>
<style lang="scss" scoped>
  .aboutContent {
    ::v-deep img {
      width: 100% !important;
    }
  }
</style>
